import { createAction } from '@reduxjs/toolkit';

import { errorHandler } from 'services/axiosService';
import { AppThunkDispatch } from '../store';
import { CreateTagData, TagData } from 'data/models/TaskTags';
import { deleteTaskTagsApi, getTaskTagsApi, postTaskTagsApi } from 'data/data-layer/taskTags';

const UPDATE_PARTNER_TASK_TAGS = 'UPDATE_PARTNER_TASK_TAGS';
const CREATE_PARTNER_TASK_TAGS = 'CREATE_PARTNER_TASK_TAGS';
const DELETE_PARTNER_TASK_TAGS = 'DELETE_PARTNER_TASK_TAGS';
const PARTNER_TASK_TAGS_LOADING = 'PARTNER_TASK_TAGS_LOADING';

export const updatePartnerTaskTags = createAction<TagData[]>(UPDATE_PARTNER_TASK_TAGS);
export const addPartnerTaskTags = createAction<TagData>(CREATE_PARTNER_TASK_TAGS);
export const removePartnerTaskTags = createAction<number>(DELETE_PARTNER_TASK_TAGS);
export const setPartnerTaskTagsLoading = createAction<boolean>(PARTNER_TASK_TAGS_LOADING);

export const getPartnerTaskTags =
  (partnerId: number) =>
  async (dispatch: AppThunkDispatch): Promise<TagData[] | undefined> => {
    dispatch(setPartnerTaskTagsLoading(true));
    try {
      const tags = await getTaskTagsApi(partnerId);
      dispatch(updatePartnerTaskTags(tags));
      return tags;
    } catch (error) {
      await errorHandler(dispatch, 'Failed to fetch partner task tags')(error);
      return undefined;
    } finally {
      dispatch(setPartnerTaskTagsLoading(false));
    }
  };

export const createPartnerTaskTags =
  (tag: CreateTagData) =>
  async (dispatch: AppThunkDispatch): Promise<TagData | undefined> => {
    dispatch(setPartnerTaskTagsLoading(true));
    try {
      const createdTag = await postTaskTagsApi(tag);
      dispatch(addPartnerTaskTags(createdTag));
      return createdTag;
    } catch (error) {
      await errorHandler(dispatch, 'Failed to create partner task tag')(error);
      return undefined;
    } finally {
      dispatch(setPartnerTaskTagsLoading(false));
    }
  };

export const deletePartnerTaskTags = (tagId: number) => async (dispatch: AppThunkDispatch) => {
  dispatch(setPartnerTaskTagsLoading(true));
  try {
    await deleteTaskTagsApi(tagId);
    dispatch(removePartnerTaskTags(tagId));
  } catch (error) {
    await errorHandler(dispatch, 'Failed to delete a partner task tag')(error);
  } finally {
    dispatch(setPartnerTaskTagsLoading(false));
  }
};
